import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { FavoritesAssignWidget } from '../../components/FavoritesAssignWidget';
import { useDispatch, useSelector } from 'react-redux';
import { addOffersToFolders, createFolder, getFoldersForOffer, updateOfferFolders } from '../../thunks';
import { selectFolders, selectInitialSelectedFolderIds, selectIsListLoading, selectIsShowNotification, selectIsShowOnBoardingDelete, selectSavedOfferId, selectSelectedIds } from '../../selectors';
import { addSavedOffer, hideFavoritesFoldersList, hideModalCreateFolder, hideNotification } from '../../actions';
import { checkFolderHasBeenRemoved, getArrayOfSelected } from '../../utils/folders';
import { ECreateFolderSource, ELinkOpenMode } from '../../types';
import { selectIsShowFoldersList } from '../../selectors/selectIsShowFoldersList';
import { hideOnBoardingAddVisible } from '../../utils/localStorage';
import { NotificationContainer } from '../NotificationContainer';
import { AnimationFade } from '../../components/AnimationFade';
import { jsx as _jsx } from "react/jsx-runtime";
export function FavoritesAssignWidgetContainer(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
    hideCloseButton = _ref.hideCloseButton,
    disableNotification = _ref.disableNotification,
    dealType = _ref.dealType,
    offerType = _ref.offerType,
    _ref$linkOpenMode = _ref.linkOpenMode,
    linkOpenMode = _ref$linkOpenMode === void 0 ? ELinkOpenMode.Self : _ref$linkOpenMode,
    _ref$onCreateFolder = _ref.onCreateFolder,
    onCreateFolder = _ref$onCreateFolder === void 0 ? function () {} : _ref$onCreateFolder,
    _ref$onSaveOffer = _ref.onSaveOffer,
    onSaveOffer = _ref$onSaveOffer === void 0 ? function () {} : _ref$onSaveOffer,
    _ref$onRemovedFromFol = _ref.onRemovedFromFolders,
    onRemovedFromFolders = _ref$onRemovedFromFol === void 0 ? function () {} : _ref$onRemovedFromFol,
    _ref$onWaitForLogin = _ref.onWaitForLogin,
    onWaitForLogin = _ref$onWaitForLogin === void 0 ? function () {} : _ref$onWaitForLogin,
    _ref$onClickFolderNam = _ref.onClickFolderName,
    onClickFolderName = _ref$onClickFolderNam === void 0 ? function () {} : _ref$onClickFolderNam,
    _ref$onNotificationSa = _ref.onNotificationSaveToFolder,
    onNotificationSaveToFolder = _ref$onNotificationSa === void 0 ? function () {} : _ref$onNotificationSa,
    _ref$onNotificationCh = _ref.onNotificationChangeFolder,
    onNotificationChangeFolder = _ref$onNotificationCh === void 0 ? function () {} : _ref$onNotificationCh;
  var dispatch = useDispatch();
  var folders = useSelector(selectFolders);
  var selectedIds = useSelector(selectSelectedIds);
  var offerIds = useSelector(selectSavedOfferId);
  var offerId = offerIds.length ? offerIds[0] : 0;
  var isShowFoldersList = useSelector(selectIsShowFoldersList);
  var isShowOnBoardingDelete = useSelector(selectIsShowOnBoardingDelete);
  var isListLoading = useSelector(selectIsListLoading);
  var initialSelectedFolderIDs = useSelector(selectInitialSelectedFolderIds);
  var isShowNotification = useSelector(selectIsShowNotification);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isCreating = _React$useState2[0],
    setIsCreating = _React$useState2[1];
  var handleSaveSelectedFolders = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var folderIds, folderHasBeenRemoved, success, savedInFoldersToSet;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            folderIds = getArrayOfSelected(selectedIds);
            folderHasBeenRemoved = checkFolderHasBeenRemoved(initialSelectedFolderIDs, folderIds);
            if (!(dealType && offerType && !folderHasBeenRemoved)) {
              _context.next = 8;
              break;
            }
            _context.next = 5;
            return dispatch(addOffersToFolders(offerIds, folderIds, dealType, offerType));
          case 5:
            success = _context.sent;
            _context.next = 11;
            break;
          case 8:
            _context.next = 10;
            return dispatch(updateOfferFolders(offerId, folderIds));
          case 10:
            success = _context.sent;
          case 11:
            if (success) {
              if (folderHasBeenRemoved) {
                if (onRemovedFromFolders) {
                  onRemovedFromFolders(offerId);
                }
              }
              dispatch(hideFavoritesFoldersList());
              savedInFoldersToSet = folders.filter(function (folderItem) {
                return folderIds.includes(folderItem.id);
              }).map(function (_ref3) {
                var id = _ref3.id,
                  name = _ref3.name;
                return {
                  id: id,
                  name: name
                };
              });
              dispatch(addSavedOffer({
                offerIds: offerIds,
                savedInFolders: savedInFoldersToSet,
                userHasFolders: true
              }));
            }
            if (folderIds.length) {
              if (onSaveOffer) {
                onSaveOffer(offerId, {
                  foldersCount: folderIds.length
                });
              }
            } else {
              if (onRemovedFromFolders) {
                onRemovedFromFolders(offerId);
              }
            }
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSaveSelectedFolders() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCloseFoldersList = function handleCloseFoldersList() {
    dispatch(hideFavoritesFoldersList());
  };
  var handleCreateFolder = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, source) {
      var newFolder;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsCreating(true);

            // eslint-disable-next-line
            _context2.next = 3;
            return dispatch(createFolder(name));
          case 3:
            newFolder = _context2.sent;
            if (onCreateFolder) {
              onCreateFolder(name, offerId);
            }
            if (source === ECreateFolderSource.Notification && newFolder) {
              dispatch(hideModalCreateFolder());
              dispatch(updateOfferFolders(offerId, [newFolder.id]));
              dispatch(addSavedOffer({
                offerIds: offerId,
                savedInFolders: [{
                  id: newFolder.id,
                  name: newFolder.name
                }],
                userHasFolders: true
              }));
              if (onSaveOffer) {
                onSaveOffer(offerId, {
                  foldersCount: 1
                });
              }
            }
            setIsCreating(false);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleCreateFolder(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleHide = function handleHide() {
    dispatch(hideNotification());
  };
  var handleOpenFoldersList = React.useCallback(function () {
    hideOnBoardingAddVisible();
    dispatch(getFoldersForOffer({
      offerId: offerId
    }));
  }, [dispatch, offerId]);
  var handleClickFolderName = function handleClickFolderName(folderId) {
    if (onClickFolderName) {
      onClickFolderName(offerId, folderId);
    }
  };
  var handleSaveToFolder = React.useCallback(function () {
    if (onNotificationSaveToFolder) {
      onNotificationSaveToFolder(offerId);
    }
  }, [offerId, onNotificationSaveToFolder]);
  var handleChangeFolder = React.useCallback(function () {
    if (onNotificationChangeFolder) {
      onNotificationChangeFolder(offerId);
    }
  }, [offerId, onNotificationChangeFolder]);
  return /*#__PURE__*/_jsx(FavoritesAssignWidget, {
    selectedIds: selectedIds,
    isShowFoldersList: isShowFoldersList,
    isShowOnBoardingDelete: isShowOnBoardingDelete,
    isListLoading: isListLoading,
    isCreating: isCreating,
    hideCloseButton: hideCloseButton,
    onCreateFolder: handleCreateFolder,
    onSaveSelectedFolders: handleSaveSelectedFolders,
    onHide: handleHide,
    onCloseFoldersList: handleCloseFoldersList,
    onOpenFoldersList: handleOpenFoldersList,
    children: /*#__PURE__*/_jsx(AnimationFade, {
      show: isShowNotification && !disableNotification,
      children: /*#__PURE__*/_jsx(NotificationContainer, {
        linkOpenMode: linkOpenMode,
        isAuthenticated: isAuthenticated,
        canChangeFolder: offerIds.length <= 1,
        onClickName: handleClickFolderName,
        onHide: handleHide,
        onWaitForLogin: onWaitForLogin,
        onSaveToFolder: handleSaveToFolder,
        onChangeFolder: handleChangeFolder
      })
    })
  });
}